export type MenuFooterIconName =
  | 'shield-check'
  | 'leaf'
  | 'sparkles'
  | 'armchair'
  | 'hand'
  | 'layers'
  | 'droplets'
  | 'shield'
  | 'palette'
  | 'calendar'
  | 'map-pin'
  | 'lightbulb'
  | 'clock'
  | 'heart'

export type MenuFooterStatement = {
  id: string
  text: string
  icon: MenuFooterIconName
}

/** One line each at print footer width (A4, 13px) */
export const menuFooterStatements: readonly MenuFooterStatement[] = [
  {
    id: 'sanitation',
    icon: 'shield-check',
    text: 'Strict sanitation — tools and stations disinfected between every visit.',
  },
  {
    id: 'natural',
    icon: 'leaf',
    text: 'We prioritize natural nail health over speed or shortcuts.',
  },
  {
    id: 'finish',
    icon: 'sparkles',
    text: 'Long-lasting finishes, applied with care so your set wears beautifully.',
  },
  {
    id: 'comfort',
    icon: 'armchair',
    text: 'Comfortable chairs, clean stations, and calm service throughout.',
  },
  {
    id: 'cuticle',
    icon: 'hand',
    text: 'Professional cuticle care with sanitized implements every visit.',
  },
  {
    id: 'gel',
    icon: 'lightbulb',
    text: 'Gel and structured sets shaped to your length — honest guidance always.',
  },
  {
    id: 'removal',
    icon: 'droplets',
    text: 'Thoughtful removal — soak and e-file only when right for your nails.',
  },
  {
    id: 'protection',
    icon: 'shield',
    text: 'We protect natural nails and never over-thin when product is needed.',
  },
  {
    id: 'art',
    icon: 'palette',
    text: 'Add-on art priced clearly — ask your tech what fits your visit.',
  },
  {
    id: 'booking',
    icon: 'calendar',
    text: 'Book online anytime; walk-ins welcome when time allows.',
  },
  {
    id: 'salon',
    icon: 'map-pin',
    text: 'Full-service manicures, pedicures, gel, and nail art in Cerritos.',
  },
  {
    id: 'refined',
    icon: 'lightbulb',
    text: 'Your set should look refined in person and in photos — our standard.',
  },
  {
    id: 'time',
    icon: 'clock',
    text: 'We take the time your nails need, not what a rushed menu demands.',
  },
  {
    id: 'advice',
    icon: 'lightbulb',
    text: 'Questions on length, removal, or fill vs. new set? Happy to advise.',
  },
  {
    id: 'gratitude',
    icon: 'heart',
    text: 'Thank you for choosing a salon of craft, cleanliness, and respect.',
  },
]

export function getMenuFooterStatement(pageNumber: number): MenuFooterStatement {
  const index = Math.max(0, pageNumber - 2) % menuFooterStatements.length
  return menuFooterStatements[index]!
}
